export default {
  LOAD_LIST_NATURALNESS(state, data) {
    state.listNaturalness = data
  },
  PREPARE_TO_EDIT_NATURALNESS(state, data) {
    state.naturalness = data
  },
  RESET_NATURALNESS(state) {
    state.naturalness = {
      ativo: true,
      nome: '',
    }
  },
}
